var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"//at.alicdn.com/t/font_2292361_sbn60avye6c.css"}}),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }